import Vue from "vue";
import VueAnalytics from "vue-analytics";
import VueLogger from "vuejs-logger";
import App from "./App.vue";
import router from "./router";
import formValidator from "./mixins/form-validator";
require("./libs/iframe-resizer-contentwindow");
import IframeSizer from "./plugins/iframesizer";
import AdobeLaunch from "./plugins/adobe-launch";
import store from "./store";
import config from "./config";
import pixels from "./pixels";

const isProduction = process.env.NODE_ENV === "production";

if (isProduction) {
  require("./libs/tealeaf");
}

// Configuración del módulo
Vue.use(config);

/** Activar plugin iframesizer */
Vue.use(IframeSizer);

// Vue Logger
Vue.use(VueLogger, {
  isEnabled: true,
  logLevel: isProduction ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true
});

/** Inyectar Adobe Launch en runtime según hostname */
if (window.__PRERENDER_INJECTED === undefined) {
  Vue.use(AdobeLaunch);
}

// Pixeles
// (llamar al último)
Vue.use(pixels);

/**
 * Instanciar la app luego de obtener y
 * aplicar la configuración del módulo
 */
config.start(() => {
  // Inicializar la app
  const BBVA_APP = new Vue({
    router,
    store,
    mixins: [formValidator],
    render: h => h(App),
    mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
  }).$mount("#app");

  // Google Analytics
  // Necesitamso el config del id
  // por eso llamamos acá
  if (config.get() && config.get().googleAnalyticsId) {
    Vue.use(VueAnalytics, {
      id: config.get().googleAnalyticsId,
      router,
      autoTracking: {
        exception: true,
        pageviewOnLoad: false
      }
    });
  }

  // Agregar timestamp de versionado si existe
  let app_version = process.env.VUE_APP_BBVA_VERSION || null;
  if (app_version) {
    BBVA_APP.version = app_version;
  }

  // Exponemos la instancia al scope global
  // Útil para hacer modificaciones desde afuera
  window.BBVA_APP = BBVA_APP;
  return BBVA_APP;
});
